import { render, staticRenderFns } from "./DeleteEmbedDialog.vue?vue&type=template&id=be531be0&"
import script from "./DeleteEmbedDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteEmbedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports